<template>
  <div>
    <h2>{{ $t("views.products.detail.title") }}</h2>

    <entity-detail-table
      :entityKey="eParent.key"
      :entityId="eParent.id"
      :readOnly="$store.getters['profile/isReadOnlyTenant'](entity.tenantId)"
      @control:input="onInput"
      @control:change="onChange"
      @entity:save="onSave"
    />

    <table class="table mt-5">
      <tr>
        <th>{{ $t("views.products.detail.prices.price") }}</th>
        <th>{{ $t("views.products.detail.prices.vatratetitle") }}</th>
      </tr>
      <tr v-for="(price, index) in prices" :key="index">
        <td>{{ price.price.toFixed(2) }} {{ price.currency }}</td>
        <td>{{ $t(`views.products.detail.prices.vatrate.${price.vatRate}`) }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import MixinEntityBase from "@/components/mixins/EntityBase";
import EntityDetailTable from "@/components/entity/DetailTable";

export default {
  name: "Products.Detail",
  mixins: [MixinEntityBase],
  components: {
    EntityDetailTable,
  },
  computed: {
    entity() {
      return (this.$store.getters[`${this.eParent.key}/getEntity`](this.eParent.id) || {}).value || {};
    },
    prices() {
      if (
        this.entityParent == null ||
        this.entityParent.value == null ||
        this.entityParent.value.prices == null ||
        this.entityParent.value.prices.length === 0
      ) {
        return [];
      }
      return this.entityParent.value?.prices[0]?.datas;
    },
  },
  methods: {
    onInput(controlValue) {
      /* do something with controlValue = { [propKey]: value } */
    },
    onChange(controlValue) {
      /* do something with controlValue = { [propKey]: value } */
    },
    onSave(entity) {
      this.$store.dispatch(`${this.eParent.key}/updateEntity`, entity);
    },
  },
};
</script>

<style lang="scss"></style>
